import React from 'react';

interface ConnectionStatusProps {
    isAuthenticating: boolean;
    isConnected: boolean;
    error: string | null; // Pass error to potentially display specific connection errors
}

const ConnectionStatus: React.FC<ConnectionStatusProps> = ({ isAuthenticating, isConnected, error }) => {
    let message = "Подключение к сервису WhatsApp...";
    if (isAuthenticating) {
        message = "Аутентификация с WhatsApp...";
    }
    // If there's a connection-related error, display it instead of the generic message
    // Keep the error check in English as it matches the error message from the backend/socket
    if (!isConnected && !isAuthenticating && error && error.toLowerCase().includes('ошибка подключения')) {
        message = error; // Display the specific Russian error message received
    }

    return (
        <div className="flex flex-col items-center justify-center h-screen p-4">
            <p className="text-lg text-gray-700 animate-pulse">{message}</p>
            {/* Optionally add a spinner here */}
        </div>
    );
};

export default ConnectionStatus;
